import { PageHeader } from '@ant-design/pro-layout';
import { Row, Typography } from 'antd';
import { useEffect } from 'react';
import { Link, useMatch, useNavigate, useResolvedPath } from 'react-router-dom';
import { RouteDefinition, VerticalTabs } from '../../../shared/vertical-tabs';
import { SubPageLayout } from '../sub-page-layout';
import { StaffEdit } from './staff-edit';
import { StaffView } from './staff-view';

interface StaffDetailsProps {}

export const StaffDetails: React.FC<StaffDetailsProps> = () => {
  const navigate = useNavigate();
  const currentRoutePath = useResolvedPath('').pathname;
  const currentRouteMatch = useMatch(`${currentRoutePath}`);
  const pageTitle = location.pathname.includes('edit') ? 'Staff Edit' : 'Staff Details';

  const pages = [
    {
      id: '1',
      path: 'staff-details',
      title: 'General',
      icon: undefined
    }
  ];

  const routes: RouteDefinition[] = [
    { id: '1', path: '', element: <StaffView /> },
    { id: '2', path: 'view', element: <StaffView /> },
    { id: '3', path: '/edit', element: <StaffEdit /> }
  ];

  const configPageNavigationMenu = pages.map((page) => ({
    key: page.id,
    label: <Link to={page.path}>{page.title}</Link>,
    style: { width: '80%' }
  }));

  useEffect(() => {
    if (currentRouteMatch) {
      navigate(routes[0].path); // Redirect to 1st menu item
    }
  }, [currentRouteMatch, navigate]);

  return (
    <SubPageLayout
      header={
        <PageHeader
          title={<Typography.Title style={{ paddingBottom: '0px', fontSize: '30px', marginTop: '12px' }}>{pageTitle}</Typography.Title>}
          onBack={() => navigate(-1)}
        ></PageHeader>
      }
    >
      <Row style={{ padding: '32px', minHeight: '100vh' }}>
        <VerticalTabs routes={routes} menuItems={configPageNavigationMenu} />
      </Row>
    </SubPageLayout>
  );
};
